import {getVersion} from '@aboutyou/config';
import {
  createStateProvider,
  TrackingClient,
  TrackingClientStateHolder,
} from '@aboutyou/legacy-tracking-sdk';
import {InitialPageInfo} from '@aboutyou/legacy-tracking-sdk/src/ay-tracking/providers/gtm/helpers/clientState';

// generate tracking client
const appVersion = '6.0';
const gitHash = getVersion();

function getGtmTrackingClient({
  gtmClientParams,
}: {
  gtmClientParams: {
    shopIds: {
      shopId: number;
    };
    featureFlags: {
      isTrackOriginClick: boolean;
      enableGAVersion: {GA3: boolean; GA4: boolean};
    };
    referrer: string;
    locale: string;
    currency: string;
    search: string;
    currentPage: InitialPageInfo;
  };
}) {
  if (!process.browser) {
    return {track: () => {}} as unknown as TrackingClient;
  }

  if (process.env.NODE_ENV === 'test') {
    return {track: () => {}} as unknown as TrackingClient;
  }

  // THIS IS TEMP IMPLEMENTATION OF SHARED STATE IN TRACKING SDK
  // REMOVE THIS AS SOON STACKS ARE MIGRATED TO TADARIDA
  // WE DO THIS TO SHARE STATE BETWEEN APPS
  // OTHERWISE THE SKD WONT BE AWARE OF THE CURENT STATE AND CANNT TRACK ACCORDINGLY

  const {shopId} = gtmClientParams.shopIds;
  const {isTrackOriginClick, enableGAVersion} = gtmClientParams.featureFlags;
  const clientState = (): TrackingClientStateHolder => {
    if (window.clientState === undefined) {
      window.clientState = createStateProvider({
        shopId,
        childShopId: null,
        appVersion,
        gitHash,
        featureFlags: {
          shouldTrackOriginClick: isTrackOriginClick,
          enableGAVersion: {
            GA3Version: enableGAVersion.GA3,
            GA4Version: enableGAVersion.GA4,
          },
        },
        referrer: gtmClientParams.referrer,
        // shop gender is not yet set on this stage
        shop_gender: '',
        locale: gtmClientParams.locale,
        shop_currency: gtmClientParams.currency,
        parameter: gtmClientParams.search,
        currentPage: gtmClientParams.currentPage,
      });
    }
    return window.clientState;
  };
  return new TrackingClient(clientState());
}

export function getTrackingClient({
  gtmClientParams,
}: {
  gtmClientParams: {
    shopIds: {
      shopId: number;
    };
    featureFlags: {
      isTrackOriginClick: boolean;
      enableGAVersion: {GA3: boolean; GA4: boolean};
    };
    referrer: string;
    locale: string;
    currency: string;
    search: string;
    currentPage: InitialPageInfo;
  };
}) {
  const gtmTrackingClient = getGtmTrackingClient({gtmClientParams});
  if (gtmTrackingClient === null) {
    throw new Error('no gtm client');
  }

  return gtmTrackingClient;
}
